import React from "react";
import styles from "./RelatedNewsCard.module.sass";
import { useNavigate } from "react-router-dom";
export default function relatedNewsCard({ image, url, title, category, date }) {
  const navigate = useNavigate();
  return (
    <div
      className={styles.container}
      onClick={() => navigate(`/news/${url}`)}
      style={{ cursor: "pointer" }}
    >
      <div className={styles.top}>
        <img
          src={`${process.env.REACT_APP_API_SERVER_URL}/${image}`}
          alt="related new image"
        />
      </div>
      <div className={styles.bottom}>
        <div>
          <p>{category}</p>
          <p>{date}</p>
        </div>
        <h5>{title}</h5>
      </div>
    </div>
  );
}
